import lodashGet from 'lodash/get';
function getValue(spectrum, jpath) {
    const value = lodashGet(spectrum, jpath);
    if (typeof value === 'string') {
        return value;
    }
    if (['number', 'boolean'].includes(typeof value)) {
        return String(value);
    }
    if (value) {
        return JSON.stringify(value);
    }
    return value;
}
function isInstanceOfOneDimensionColor(item) {
    return 'color' in item;
}
export function getCustomColor(spectrum, colors) {
    if (!colors || colors.length === 0)
        return null;
    let color = null;
    for (const item of colors) {
        const value = getValue(spectrum, item.jpath);
        if (value &&
            item.value &&
            value.toLocaleLowerCase().includes(item.value.toLocaleLowerCase())) {
            if (isInstanceOfOneDimensionColor(item)) {
                color = item.color;
            }
            else {
                const { negativeColor, positiveColor } = item;
                color = { negativeColor, positiveColor };
            }
            break;
        }
    }
    return color;
}
